export function calculatePaxSummary(lineItems) {
    // Create an empty object to store the count for each pax type
    const paxSummary = {};
  
    // Iterate over each line item
    lineItems.forEach(item => {
      const { pax_type_name, quantity } = item;
  
      // If pax type exists in the summary, increment the quantity, otherwise set it
      if (paxSummary[pax_type_name]) {
        paxSummary[pax_type_name] += quantity;
      } else {
        paxSummary[pax_type_name] = quantity;
      }
    });
  
    // Convert the paxSummary object to an array of formatted strings
    const result = Object.entries(paxSummary).map(([paxType, count]) => `${count} ${paxType}`);
  
    // Join the formatted strings with ', ' and return the result
    return result.join(', ');
  }
  